import React from 'react';
import { Button, Typography, Tooltip, Dropdown, Menu, Tag } from 'antd';
import styled from 'styled-components';
import {
    getExecutionRequestStatusDisplayColor,
    getExecutionRequestStatusDisplayText,
    CLI_INGESTION_SOURCE,
    SCHEDULED_INGESTION_SOURCE,
    MANUAL_INGESTION_SOURCE,
    RUNNING,
    SUCCESS,
} from '../utils';
import { ReactComponent as IconMoreVert } from '../../../../images/icon-more-vert.svg';

const Wrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export function TimeColumn(time: string) {
    const date = time && new Date(time);
    const localTime = date && `${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`;
    return <Typography.Text>{localTime || 'None'}</Typography.Text>;
}

interface StatusColumnProps {
    status: string;
    record: any;
    setFocusExecutionUrn: (urn: string) => void;
}

export function StatusColumn({ status, record, setFocusExecutionUrn }: StatusColumnProps) {
    const text = getExecutionRequestStatusDisplayText(status);
    const color = getExecutionRequestStatusDisplayColor(status);

    let statusClass = 'f-tag-gray-outline';
    if (color === 'green') {
        statusClass = 'ant-tag-success';
    } else if (color === 'red') {
        statusClass = 'des-tag';
    }

    return (
        <Tag
            onClick={() => setFocusExecutionUrn(record.urn)}
            className={`label-tag f-outlined ma-0 ${statusClass} ${text === 'Succeeded' ? 'clickable' : ''}`}
        >
            {text || 'Pending'}
        </Tag>
    );
}

export function SourceColumn(source: string) {
    return (
        <Tag className="label-tag grey-tag-light ma-0">
            {(source === MANUAL_INGESTION_SOURCE && 'Manual Execution') ||
                (source === SCHEDULED_INGESTION_SOURCE && 'Scheduled Execution') ||
                (source === CLI_INGESTION_SOURCE && 'CLI Execution') ||
                'N/A'}
        </Tag>
    );
}

interface ButtonsColumnProps {
    record: any;
    handleViewDetails: (urn: string) => void;
    handleCancelExecution: (urn: string) => void;
    handleRollbackExecution: (runId: string) => void;
    isLoading: boolean;
}

export function ButtonsColumn({
    record,
    handleViewDetails,
    handleCancelExecution,
    handleRollbackExecution,
    isLoading,
}: ButtonsColumnProps) {
    return (
        <Wrapper>
            <Dropdown
                trigger={['click']}
                placement="bottomRight"
                overlay={
                    <Menu className="f-dropdown-small">
                        {record.urn && navigator.clipboard && (
                            <Tooltip title="Copy Execution Request URN">
                                <Menu.Item
                                    onClick={() => {
                                        navigator.clipboard.writeText(record.urn);
                                    }}
                                >
                                    Copy URN
                                </Menu.Item>
                            </Tooltip>
                        )}
                        {record.duration && (
                            <Menu.Item onClick={() => handleViewDetails(record.urn)}>Details</Menu.Item>
                        )}
                        {record.status === RUNNING && (
                            <Menu.Item onClick={() => handleCancelExecution(record.urn)}>Cancel</Menu.Item>
                        )}
                        {record.status === SUCCESS && record.showRollback && (
                            <Menu.Item disabled={isLoading} onClick={() => handleRollbackExecution(record.id)}>
                                Rollback
                            </Menu.Item>
                        )}
                    </Menu>
                }
            >
                <Button
                    type="text"
                    title="More Actions"
                    icon={<IconMoreVert />}
                    aria-label="More Actions"
                    className="icon-button ma-0"
                />
            </Dropdown>
        </Wrapper>
    );
}
